// Lazy background images.
// Markup uses <div class="bg"><img data-src="..."></div>: the <img> is hidden
// via CSS and only its URL is used as the container's background-image. We defer
// loading until the element is near the viewport (IntersectionObserver), so the
// browser never downloads off-screen background photos (slider, cards, etc.).
//
// Slides 2+ use a different strategy: no <img> in the HTML at all (data-lazy-src
// on the container). swiper.js injects the <img> on navigation and calls
// loadBgNow() directly — no observer needed since the slide is already in view.

let observer;

function applyBg(el) {
  if (el.dataset.bgLoaded) return;

  const img = el.querySelector('img');
  if (!img) return;

  const src = img.getAttribute('data-src') || img.getAttribute('src');
  if (!src) return;

  el.dataset.bgLoaded = '1';

  const image = new Image();
  image.src = src;
  image.onload = () => {
    el.style.backgroundImage = `url(${src})`;
    el.classList.add('bg--loaded');
  };
}

/**
 * Apply a background image to a .bg element immediately (no observer).
 * Called by swiper.js when a lazy slide is navigated into view.
 */
export function loadBgNow(el, src) {
  if (el.dataset.bgLoaded) return;
  el.dataset.bgLoaded = '1';

  const image = new Image();
  image.src = src;
  image.onload = () => {
    el.style.backgroundImage = `url(${src})`;
    el.classList.add('bg--loaded');
  };
}

export function initBg(root = document) {

  // Fallback: no IntersectionObserver -> load everything right away.
  if (!('IntersectionObserver' in window)) {
    root.querySelectorAll('.bg').forEach(applyBg);
    return;
  }

  if (!observer) {
    observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          applyBg(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' }); // start loading a bit before it scrolls in
  }

  root.querySelectorAll('.bg').forEach(el => {
    if (el.dataset.bgObserved) return;
    el.dataset.bgObserved = '1';
    observer.observe(el);
  });
}
